import { render, staticRenderFns } from "./MenuOptions.vue?vue&type=template&id=060612a4&scoped=true&"
import script from "./MenuOptions.vue?vue&type=script&lang=js&"
export * from "./MenuOptions.vue?vue&type=script&lang=js&"
import style0 from "./MenuOptions.vue?vue&type=style&index=0&id=060612a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060612a4",
  null
  
)

export default component.exports